import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
    // Завантажуємо кошик з localStorage, якщо він там є
    const [cartItems, setCartItems] = useState(() => {
        const localData = localStorage.getItem('love_stitch_cart');
        return localData ? JSON.parse(localData) : [];
    });

    // Щоразу, коли кошик змінюється, зберігаємо його в localStorage
    useEffect(() => {
        localStorage.setItem('love_stitch_cart', JSON.stringify(cartItems));
    }, [cartItems]);

    // Додавання товару в кошик
    const addToCart = (product, quantity = 1, size = 'S') => {
        setCartItems((prevItems) => {
            // Перевіряємо, чи є вже такий товар З ТАКИМ ЖЕ РОЗМІРОМ у кошику
            const existingItemIndex = prevItems.findIndex(
                (item) => item.id === product.id && item.size === size
            );

            if (existingItemIndex > -1) {
                // Якщо є, просто збільшуємо його кількість
                const newItems = [...prevItems];
                newItems[existingItemIndex].quantity += quantity;
                return newItems;
            } else {
                // Якщо немає, додаємо як новий елемент кошика
                return [...prevItems, { ...product, quantity, size }];
            }
        });
    };

    // Видалення товару з кошика
    const removeFromCart = (id, size) => {
        setCartItems((prevItems) =>
            prevItems.filter((item) => !(item.id === id && item.size === size))
        );
    };

    // Зміна кількості (+1 або -1) безпосередньо в кошику
    const updateQuantity = (id, size, delta) => {
        setCartItems((prevItems) =>
            prevItems.map((item) => {
                if (item.id === id && item.size === size) {
                    const newQty = item.quantity + delta;
                    return { ...item, quantity: newQty > 0 ? newQty : 1 };
                }
                return item;
            })
        );
    };

    // Очищення кошика після успішної оплати
    const clearCart = () => {
        setCartItems([]);
    };

    // Рахуємо загальну вартість
    const cartTotal = cartItems.reduce(
        (total, item) => total + item.price * item.quantity,
        0
    );

    // Рахуємо загальну кількість товарів у кошику (для іконки в шапці)
    const cartCount = cartItems.reduce((count, item) => count + item.quantity, 0);

    return (
        <CartContext.Provider
            value={{
                cartItems,
                addToCart,
                removeFromCart,
                updateQuantity,
                clearCart,
                cartTotal,
                cartCount,
            }}
        >
            {children}
        </CartContext.Provider>
    );
};

// Кастомний хук для швидкого доступу до кошика на будь-якій сторінці
export const useCart = () => useContext(CartContext);